import { RootState } from '../../app/store';
import { openToast } from '../../utility/toast';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {   InspectionAnalysisData, InspectionAnalysisState } from 
  '../../model/inspectionAnalysisInterface';
import { fetchData, fetchDataAssign  } 
  from '../../services/inspectionAnalysisAPI';



const initialState: InspectionAnalysisState = {
  analysis: {
    data: [],
    status: 'idle'
  },
  analysisFiltered: {
    data: [],
    status: 'idle'
  },
  users: {
    data: undefined,
    status: 'idle'
  }
};

export const listDataAsync = createAsyncThunk(
  'inspectionAnalysis/listData',
  async (ctx: string) => {
    try {
      const response = await fetchData(ctx);
      
      

      return response;
    } catch (e: any) {
      openToast({
        severity: 'error',
        alertMessage: e?.data?.errorMessage ?? 'FetchKO'
      });
      return Promise.reject(e.data ? e.data : e);
    }
  }
);

export const listDataFilteredAsync = createAsyncThunk(
  'inspectionAnalysis/listDataFiltered',
  async (data: {
    defects: InspectionAnalysisData[],
    filter: any
  }
  ) => {
    try {
      let defectsMain: InspectionAnalysisData[] = data?.defects;
      if (defectsMain) {
        if (data?.filter?.mission) {
          defectsMain = defectsMain.filter(
            (it: InspectionAnalysisData) => it.taskLabel === data?.filter?.mission);
          if (data?.filter?.flight) {
            defectsMain = defectsMain.filter(
              (it: InspectionAnalysisData) => it.jobLabel === data?.filter?.flight);
          }
        }
        if (data?.filter?.defect) {
          defectsMain = defectsMain.filter(
            (it: InspectionAnalysisData) => it.name === data?.filter?.defect);
        }
        if (data?.filter?.assignTo) {
          defectsMain = defectsMain.filter(
            (it: InspectionAnalysisData) => (it.defectAssignees ?? [])
              .indexOf(data?.filter?.assignTo) != -1);
        }
        if (data?.filter?.owner) {
          defectsMain = defectsMain.filter(
            (it: InspectionAnalysisData) => (it.defectOwners ?? [])
              .indexOf(data?.filter?.owner) != -1);
        }

        return defectsMain.filter(
          (it: InspectionAnalysisData) =>
            (data?.filter?.states ?? []).indexOf(it.status) != -1);
      }

      return [];
    } catch (e: any) {
      openToast({
        severity: 'error',
        alertMessage: e?.data?.errorMessage ?? 'FetchKO'
      });
      return Promise.reject(e.data ? e.data : e);
    }
  }
);
 



export const listAssignDefectAsync = createAsyncThunk(
  'inspectionAnalysis/listAssign',
  async (data: {ctx: string, role: string}) => {
    try {
      const response = await fetchDataAssign(data.role, data.ctx); 
      return response?.data;
    } catch (e: any) {
      openToast({
        severity: 'error',
        alertMessage: e?.data?.errorMessage ?? 'FetchKO'
      });
      return Promise.reject(e.data ? e.data : e);
    }
  }
);



export const inspectionAnalysisSlice = createSlice({
  name: 'inspectionAnalysis',
  initialState,
  reducers: {
    resetlistDefects: (state) => {
      state.analysis.status = 'idle';
      state.analysis.data = [];
    },
    resetlistFilteredDefects: (state) => {
      state.analysisFiltered.status = 'idle';
      state.analysisFiltered.data = [];
    },
    resetlistUsersAssign: (state) => {
      state.users.status = 'idle';
      state.users.data = undefined;
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(listDataAsync.pending, (state) => {
        state.analysis.status = 'loading';
      })
      .addCase(listDataAsync.fulfilled, (state, action) => {
        state.analysis.status = 'success'; 
        state.analysis.data = action.payload;
      })
      .addCase(listDataAsync.rejected, (state: any, action) => {
        state.analysis.status = 'failed';
        state.analysis.data = action.error;
      })
      .addCase(listDataFilteredAsync.pending, (state) => {
        state.analysisFiltered.status = 'loading';
      })
      .addCase(listDataFilteredAsync.fulfilled, (state, action) => {
        state.analysisFiltered.status = 'success'; 
        state.analysisFiltered.data = action.payload;
      })
      .addCase(listDataFilteredAsync.rejected, (state: any, action) => {
        state.analysisFiltered.status = 'failed';
        state.analysisFiltered.data = action.error;
      }) 
      .addCase(listAssignDefectAsync.pending, (state) => {
        state.users.status = 'loading';
      })
      .addCase(listAssignDefectAsync.fulfilled, (state, action) => {
        state.users.status = 'success';
        state.users.data = action.payload;
      })
      .addCase(listAssignDefectAsync.rejected, (state: any, action) => {
        state.users.status = 'failed';
        state.users.data = action.error;
      });
 

  }
});
export const {
  resetlistDefects,  
  resetlistFilteredDefects,
  resetlistUsersAssign
} = inspectionAnalysisSlice.actions;

export const listDefectsState = (state: RootState) =>
  state.inspectionAnalysis.analysis;
export const listDefectsFilteredState = (state: RootState) =>
  state.inspectionAnalysis.analysisFiltered;
export const listUsersAssignState = (state: RootState) =>
  state.inspectionAnalysis.users;

export default inspectionAnalysisSlice.reducer;
